import React from "react";
import { AppleIcon, GoogleIcon } from "./OAuthIcons";
import { Button, ButtonLink } from "../ui/Buttons";

const BUTTON_CLASS = "w-full py-3 font-medium";

type OAuthProviders = {
  google: boolean;
  apple: boolean;
};

type AuthRoutes = {
  authGoogle: string;
  authApple: string;
};

type AuthProviderButtonsProps = {
  oauthProviders: OAuthProviders;
  routes: AuthRoutes;
  emailButton?: {
    label: string;
    onClick: () => void;
  };
  showDividerAfter?: boolean;
};

export const AuthProviderButtons: React.FC<AuthProviderButtonsProps> = ({
  oauthProviders,
  routes,
  emailButton,
  showDividerAfter = false,
}) => {
  const hasOAuth = oauthProviders.google || oauthProviders.apple;
  const hasContent = hasOAuth || emailButton;
  if (!hasContent) return null;

  return (
    <div
      className={
        showDividerAfter ? "mb-6 flex flex-col gap-3" : "flex flex-col gap-3"
      }
    >
      {oauthProviders.google && (
        <ButtonLink
          href={routes.authGoogle}
          variant="surface"
          className={BUTTON_CLASS}
        >
          <GoogleIcon />
          Continue with Google
        </ButtonLink>
      )}
      {oauthProviders.apple && (
        <ButtonLink
          href={routes.authApple}
          variant="surface"
          className={BUTTON_CLASS}
        >
          <AppleIcon />
          Continue with Apple
        </ButtonLink>
      )}
      {emailButton && (
        <Button
          type="button"
          variant="surface"
          className={BUTTON_CLASS}
          onClick={emailButton.onClick}
        >
          {emailButton.label}
        </Button>
      )}
      {showDividerAfter && (
        <div className="flex items-center gap-3">
          <div className="h-px flex-1 bg-border" />
          <span className="text-xs text-muted-foreground">or</span>
          <div className="h-px flex-1 bg-border" />
        </div>
      )}
    </div>
  );
};
